module.exports = __webpack_public_path__ + "img/bg_lab_door_morning.cf586788.jpg";